/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eta_Window_Early_MorningInputs */

const en_eta_window_early_morning = /** @type {(inputs: Eta_Window_Early_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before 8:00`)
};

const ja_eta_window_early_morning = /** @type {(inputs: Eta_Window_Early_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8時前`)
};

const fr_eta_window_early_morning = /** @type {(inputs: Eta_Window_Early_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant 8h00`)
};

const de_eta_window_early_morning = /** @type {(inputs: Eta_Window_Early_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor 8:00`)
};

/**
* | output |
* | --- |
* | "Before 8:00" |
*
* @param {Eta_Window_Early_MorningInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const eta_window_early_morning = /** @type {((inputs?: Eta_Window_Early_MorningInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eta_Window_Early_MorningInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eta_window_early_morning(inputs)
	if (locale === "ja") return ja_eta_window_early_morning(inputs)
	if (locale === "fr") return fr_eta_window_early_morning(inputs)
	return de_eta_window_early_morning(inputs)
});